import React from "react";
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from "./pages/Home";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Introduce from "./pages/Introduce";
import Business from "./pages/Business";
import Lab from "./pages/Lab";
import Result from "./pages/Result";
import Cs from "./pages/Cs";

function App() {
  return (
    <div className="App">
      <Header />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home/>}></Route>
          <Route path="/introduce/:type" element={<Introduce/>}></Route>
          <Route path="/business/:type" element={<Business/>}></Route>
          <Route path="/lab/:type" element={<Lab/>}></Route>
          <Route path="/result/:type" element={<Result/>}></Route>
          <Route path="/cs/:type" element={<Cs/>}></Route>
        </Routes>
      </BrowserRouter>
      <Footer />
    </div>
  );
}

export default App;
